const exclusiveAlumniPrivilegesKeys = [
        {
            id : 'fullAccessDirectoryMarketplace',
            text : "Full access to alumni directory and marketplace",
            isDefault: true
        }, 
        {
            id : 'exclusiveNetworkingEvents',
            text : "Exclusive networking events and webinars",
            isDefault: true
        }, 
        {
            id : 'careerDevelopmentResources',
            text : "Career development resources & mentorship",
            isDefault: true
        }, 
        {
            id : 'alumniOnlyJobBoard',
            text : "Alumni-only job board",
            isDefault: true
        }, 
        {
            id : 'giftVouchersCoupons',
            text : "Gift vouchers and coupons",
            isDefault: false,
            toolTip: 'Explore from a list specially curated gift voucher and coupons from popular companies offering variety of products at discounted prices'
        }, 
        {
            id : 'recognitionByInstituteOnKeyAchievements',
            text : "Recognition by institute on key achievements",
            isDefault: false,
            toolTip: 'If opted for, your profile achievements will be reviewed by the institute management, and may be chosen for different forms of recognition (Ex: A social media post, Newsletter coverage, Featured on website, Distinguished Alumni Award etc)'
        }, 
        {
            id : 'smartCard',
            text : "Smart card with alumni benefits",
            isDefault: false,
            toolTip: `An easy to carry physical tag with institute's logo that collaborates directly with Global Airline Baggage systems to expedite the return of your delayed or lost luggage`
        }, 
        {
            id : 'digitalLearnerAccess',
            text : "Digital learner access",
            isDefault: false,
            toolTip: `Get discounted access to popular news platforms'. premium articles, online course platforms and digital libraries`
        }
    ];

const networkingPreferencesKeys = [
        {
            id : 'alumniInCity',
            text : `Alumni in city`,
            img : 'icon-map-pointer.svg',
            isDefault: true
        }, 
        {
            id : 'volunteeringSocialCauses',
            text : "Volunteering for Social Causes",
            img : 'icon-civic.svg',
            isDefault: false
        }, 
        {
            id : 'batchesActiveDuringMyStay',
            text : "Batches active during my stay",
            img : 'icon-graduation-hat.svg',
            isDefault: true
        }, 
        {
            id : 'startUpEnthusiasts',
            text : "Start-up Enthusiasts",
            img : 'icon-shuttle.svg',
            isDefault: false
        }, 
        {
            id : 'marketingStalwarts',
            text : "Marketing Stalwarts",
            img : 'icon-breifcase.svg',
            isDefault: true
        }, 
        {
            id : 'sportsAndFitness',
            text : "Sports & Fitness",
            img : 'icon-basketball.svg',
            isDefault: true
        }
    ];

export default {exclusiveAlumniPrivilegesKeys, networkingPreferencesKeys }